export default class SpritePool {
  constructor(scene, Type, length) {
    this.pool = [];
    let i = length;
    while (--i > -1) {
      this.pool[i] = new Type(scene);
    }
  }

  getSprite () {
    if (this.pool.length > 0) {
      return this.pool.pop();
    }
    else {
      return null;
    }
  }

  returnSprite (sprite) {
    this.pool.push(sprite);
    // eslint-disable-next-line no-param-reassign
    sprite.visible = false;
  }

  cleanup() {
    this.pool.forEach(item => item.destroy());
  }
}